import 'react-app-polyfill/stable'
import 'core-js'
import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HashRouter as Router } from 'react-router-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from './config/MsalConfig'
import PPProvider from './Contexts/Price-Promotions/PP_Provider'
import SdfProvider from './Contexts/SDF/sdf_Provider'
import StockProvider from './Contexts/Stock/StockProvider'

// Create MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig)

const rootElement = document.getElementById('root') || document.createElement('div')
const root = createRoot(rootElement)

root.render(
  <StrictMode>
    <MsalProvider instance={msalInstance}>
      <Router>
        <PPProvider>
          <SdfProvider>
            <StockProvider>
              <App />
            </StockProvider>
          </SdfProvider>
        </PPProvider>
      </Router>
    </MsalProvider>
  </StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
